export interface ApiResponse<T> {
  data: T;
  message?: string;
  code: ApiErrorCode;
}

export interface ApiPaginatedResponse<T> extends Omit<ApiResponse<T[]>, 'data'> {
  data: T[];
  nextKey: string;
  previousKey: string;
  totalCount: number;
}

export interface StaleUsersResponse {
  staleUsers: any[];
  hasMoreUsers: boolean;
  includeAssignments: boolean;
}

export enum ApiErrorCode {
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  BadRequest = 'BadRequest',
  InternalServerError = 'InternalServerError',
  Success = 'Success',
} 